'use strict';
const { queryFirst, queryAll, addClass, hasClass, removeClass } = require('../domUtil');
const breakpoints = require('../breakpoints');

let windowWidth = window.innerWidth;
const hideClass = 'hidden-filters';
const refinementBar = queryFirst('.refinement-bar');
const searchContainerEl = queryFirst('.search-results-container');
let refinementsEl = queryFirst('.refinements');
const filterPanel = queryFirst('.filter-sticky-panel');
const hideBtn = queryFirst('.hide-filter-btn', filterPanel);
let clearBtn = queryFirst('.js-clear-filters-btn', filterPanel);
const sortOrder = queryFirst('.sort-order-menu', filterPanel)
const sortOrderBtn = queryFirst('.sort-order-menu-toggle', sortOrder);
let deliveryAccordion = queryFirst('.store-filter-container .title', refinementBar);
let firstAccordionElement = queryFirst('.accordion-container .card:not(.d-none) .title', refinementsEl);
const lastAccordionElement = queryFirst('.accordion-container:last-child', refinementsEl);
const lastTitleBtnEl = queryFirst('.title', lastAccordionElement);
const productGridViewButton = queryFirst('.product-grid-view-button:last-child', filterPanel);
let lastSubBtnEls = queryAll('button:not([disabled]), input:not([disabled]), [href]:not(.d-md-none), [tabindex]:not([tabindex="-1"])', lastAccordionElement);
let lastSubBtnEl;
if ((lastSubBtnEls || []).length) {
    lastSubBtnEl = lastSubBtnEls[lastSubBtnEls.length - 1];
}

const filterPill = queryFirst('.toggle-grid .filter-value:first-child button');
const KEYCODE_TAB = 9;
const KEYCODE_ENTER = 13;
const mql = window.matchMedia('(max-width: 767px)');
const firstProductTile = queryFirst('.product-tile-container');

const focusFirstRefinementElement = ()=> {
    deliveryAccordion = queryFirst('.store-filter-container .title', refinementBar);
    firstAccordionElement = queryFirst('.accordion-container .card:not(.d-none) .title', refinementsEl);

    if(deliveryAccordion) {
        deliveryAccordion.focus();
    } else {
        firstAccordionElement.focus();
    }
}

const toggleFilterDisplay = () => {
    if (windowWidth < breakpoints.md) {
        return;
    }

    if (searchContainerEl && hasClass(searchContainerEl, hideClass)) {
        removeClass(searchContainerEl, hideClass);
        hideBtn.setAttribute('aria-expanded', 'true');
        refinementBar.removeAttribute('tabindex');
        $(hideBtn).trigger('toggle.lp.filters', 'filter menu: show');
        setTimeout(() => {
            focusFirstRefinementElement();
        }, 700);

        return;
    }

    addClass(searchContainerEl, hideClass);
    hideBtn.setAttribute('aria-expanded', 'false');
    searchContainerEl.setAttribute('tabindex', '-1');
    $(hideBtn).trigger('toggle.lp.filters', 'filter menu: hide');
    hideBtn.focus();
};

const handleSortOrderBtn = e => {
    const sortOrderExpanded = sortOrderBtn.getAttribute('aria-expanded');
    const isEnterPressed = e.key === 'Enter' || e.keyCode === KEYCODE_ENTER;
    if (!isEnterPressed) {
        return;
    }

    if (sortOrderExpanded === 'true') {
        queryFirst('.sort-order-menu-option', sortOrder).focus();
    } else {
        sortOrderBtn.focus();
    }
};

const handleLastDensityBtn = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (!e.shiftKey) {
        firstProductTile.focus();
    }
}

const handleFilterTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (!e.shiftKey) {
        if (!(searchContainerEl && hasClass(searchContainerEl, hideClass))) {
            focusFirstRefinementElement();
        } else if (clearBtn && (searchContainerEl && hasClass(searchContainerEl, hideClass))) {
            clearBtn.focus();
        } else {
            sortOrderBtn.focus();
        }
    }
};

const handleLastElTab = e => {
    const lastElExpanded = lastTitleBtnEl.getAttribute('aria-expanded');
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (lastElExpanded === 'false' && !e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    } else if (lastElExpanded === 'true' && !e.shiftKey) {
        queryFirst('ul li:first-child button', lastAccordionElement).focus();
        e.preventDefault();
    }
};

const handleFirstElTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        hideBtn.focus();
        e.preventDefault();
    }
};

const handleLastSubBtnElTab = e => {
    if (e.target.closest('form[name=price-filter-form]')) {
        lastSubBtnEls = queryAll('button:not([disabled]), input:not([disabled]), [href]:not(.d-md-none), [tabindex]:not([tabindex="-1"])', lastAccordionElement);
        lastSubBtnEl.removeEventListener('keydown', handleLastSubBtnElTab);
        if ((lastSubBtnEls || []).length) {
            lastSubBtnEl = lastSubBtnEls[lastSubBtnEls.length - 1];
            lastSubBtnEl.addEventListener('keydown', handleLastSubBtnElTab);
        }
    }
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (!e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    }
};

const handleFirsrProductTileTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        productGridViewButton.focus();
        e.preventDefault();
    }
};

const handleFilterPillBtnTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    }
};

const mobileScrollToBottom = () => {
    if (lastAccordionElement) {
        const target = queryFirst('.title', lastAccordionElement).dataset.target;
        $(target).on('shown.bs.collapse', function () {
            queryFirst('.refinement-price').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
};

const windowTest = w => {
    if (w.matches) {
        mobileScrollToBottom();
    }
};

module.exports = () => {
    if (hideBtn) {
        hideBtn.addEventListener('click', toggleFilterDisplay);
        hideBtn.addEventListener('keydown', handleFilterTab);
    }
    if (sortOrderBtn) {
        sortOrderBtn.addEventListener('keyup', handleSortOrderBtn);
    }
    if(productGridViewButton) {
        productGridViewButton.addEventListener('keydown', handleLastDensityBtn);
    }
    if (lastTitleBtnEl) {
        lastTitleBtnEl.addEventListener('keydown', handleLastElTab);
        if (lastSubBtnEl) {
            lastSubBtnEl.addEventListener('keydown', handleLastSubBtnElTab);
        }
    }
    if (deliveryAccordion) {
        deliveryAccordion.addEventListener('keydown', handleFirstElTab);
    } else if (firstAccordionElement) {
        firstAccordionElement.addEventListener('keydown', handleFirstElTab);
    }
    if (firstProductTile) {
        firstProductTile.addEventListener('keydown', handleFirsrProductTileTab);
    }
    if (filterPill) {
        filterPill.addEventListener('keydown', handleFilterPillBtnTab);
    }

    $('body').on('search:updateProducts', function () {
        refinementsEl = queryFirst('.refinements');
        deliveryAccordion = queryFirst('.store-filter-container .title', refinementBar);
        firstAccordionElement = queryFirst('.accordion-container .card:not(.d-none) .title', refinementsEl);
        clearBtn = queryFirst('.js-clear-filters-btn', filterPanel);

        if (lastAccordionElement) {
            windowTest(mql);
        }

        if (hideBtn) {
            hideBtn.addEventListener('keydown', handleFilterTab);
        }

        if (deliveryAccordion) {
            deliveryAccordion.addEventListener('keydown', handleFirstElTab);
        } else if (firstAccordionElement) {
            firstAccordionElement.addEventListener('keydown', handleFirstElTab);
        }
    });
    if (lastAccordionElement) {
        windowTest(mql);
    }
};
